var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasRole('ui', 'UI_ENABLED_WATERMARK'))?_c('div',{staticClass:"watermark",style:(("background-image: url(" + _vm.base64Image + ");"))}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }